var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":!_vm.$vuetify.theme.dark ? 'app_div' : 'app_div_dark'}},[_c('v-main',{attrs:{"id":"main_div"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }